var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReclamation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30.326,
    viewBox: "0 0 30 30.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b03661;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3862 -3412)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3862 3412)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.388,15.008a2.527,2.527,0,0,0-1.915-.878h-.179V11.6a2.532,2.532,0,0,0-2.022-2.477v-4.6a.505.505,0,0,0-.505-.505H25.25V2.505A.505.505,0,0,0,24.744,2H7.56a.505.505,0,0,0-.505.505V6.094A2.532,2.532,0,0,0,5.033,8.571v.505H4.527A2.53,2.53,0,0,0,2,11.6V31.82a.834.834,0,0,0,.118.324.505.505,0,0,0,.388.181H27.047a2.507,2.507,0,0,0,2.5-2.135l2.429-13.158a2.527,2.527,0,0,0-.584-2.024ZM28.282,11.6V14.13H27.272V10.18A1.516,1.516,0,0,1,28.282,11.6ZM26.261,14.13H10.087v-9.1H26.261ZM8.065,3.011H24.239V4.022H9.581a.505.505,0,0,0-.505.505v9.6H8.065ZM3.011,11.6a1.516,1.516,0,0,1,1.516-1.516H5.538a.505.505,0,0,0,.505-.505V8.571A1.516,1.516,0,0,1,7.054,7.147v7A2.5,2.5,0,0,0,4.78,16.268L3.011,26.141Zm27.964,5.263L28.546,30.024a1.526,1.526,0,0,1-1.5,1.291H3.112L5.78,16.433a1.526,1.526,0,0,1,1.5-1.291H29.473a1.516,1.516,0,0,1,1.5,1.725Z",
    transform: "translate(-2 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.647,14H20.505a.505.505,0,1,0,0,1.011H33.647a.505.505,0,0,0,0-1.011Z",
    transform: "translate(-10.902 -7.935)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.505,10a.505.505,0,1,0,0,1.011H33.647a.505.505,0,0,0,0-1.011Z",
    transform: "translate(-10.902 -5.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.647,18H20.505a.505.505,0,1,0,0,1.011H33.647a.505.505,0,0,0,0-1.011Z",
    transform: "translate(-10.902 -9.913)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.647,22H20.505a.505.505,0,1,0,0,1.011H33.647a.505.505,0,0,0,0-1.011Z",
    transform: "translate(-10.902 -11.891)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3870.824 3428.31)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.992,22.553H11.319A1.321,1.321,0,0,1,10,21.234a1.253,1.253,0,0,1,.207-.7l4.826-7.9a1.312,1.312,0,0,1,2.249.007l4.832,7.907a1.229,1.229,0,0,1,.2.686,1.321,1.321,0,0,1-1.319,1.319Zm-4.837-9.673a.426.426,0,0,0-.368.2l-4.841,7.921a.39.39,0,0,0-.068.228.441.441,0,0,0,.44.44h9.673a.441.441,0,0,0,.44-.44.372.372,0,0,0-.057-.211l-4.847-7.931a.43.43,0,0,0-.372-.212Z",
    transform: "translate(-10 -12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.94,19.4a.44.44,0,0,1-.44-.44V15.44a.44.44,0,0,1,.879,0v3.518A.44.44,0,0,1,16.94,19.4Z",
    transform: "translate(-10.784 -12.362)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 0.44,
    cy: 0.44,
    rx: 0.44,
    ry: 0.44,
    transform: "translate(5.716 7.914)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReclamation);
export default __webpack_public_path__ + "static/media/iconReclamation.4d103ba9c47eb1df5060f53d2a929ac7.svg";
export { ForwardRef as ReactComponent };